<img
  class="core-image"
  [attr.crossorigin]="crossOrigin"
  [src]="imageSrc"
  (load)="loaded.emit($event)"
  (error)="error.emit($event)"
/>
